import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowDown"><Path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM8 17V15.5H16V17H8ZM12 14.5607L8.68934 11.25L9.75 10.1893L11.25 11.6893V7H12.75V11.6893L14.25 10.1893L15.3107 11.25L12 14.5607Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowDown;
